export default "__VITE_ASSET__CnY7TA6Z__"